import ShortQuestionAnswer from "./Type/ShortQuestionAnswer";
import SingleChoiceMCQ from "./Type/SingleChoiceMCQ";

export default function QuestionRenderer(props) {
    const { aiChatDetails } = props;
    const questionType = aiChatDetails?.config?.questionType;
    // console.log("Question Type:", questionType);

  switch (questionType) {
    case "single_choice_mcq":
        return (
            <SingleChoiceMCQ {...props} />
        )
    case "multiple_choice_mcq":
        return (
            <div>Multiple choice mcq</div>
        )
    case "short_answer":
        return (
            <ShortQuestionAnswer {...props} />
        )
    default:
        return (
            <div>Unknown question type</div>
        )
  }
}